export default __webpack_public_path__ + "static/media/WaveImage.37885ebf.svg";